export const BOOK_VISIT = 'BOOK_VISIT';
export const HEALTH_HISTORY = 'HEALTH_HISTORY';
export const EMERGENCY_CONTACT = 'EMERGENCY_CONTACT';
export const JOIN_COMMUNITY = 'JOIN_COMMUNITY';
export const PAST_DUE = 'PAST_DUE';
export const CANCELLED = 'CANCELLED';
export const CANCELLATION_COMPLETE = 'CANCELLATION_COMPLETE';

export interface IDashboardTask {
	id: string;
	priority: number;
	done: boolean;
	loading: boolean;
}

const initialTaskState = {
	loading: true,
	done: false,
};

const tasks: Record<string, IDashboardTask> = {
	bookVisit: {
		id: BOOK_VISIT,
		priority: 1,
		...initialTaskState,
	},
	healthHistory: {
		id: HEALTH_HISTORY,
		priority: 2,
		...initialTaskState,
	},
	emergencyContact: {
		id: EMERGENCY_CONTACT,
		priority: 3,
		...initialTaskState,
	},
	joinCommunity: {
		id: JOIN_COMMUNITY,
		priority: 4,
		...initialTaskState,
	},
	pastDue: {
		id: PAST_DUE,
		priority: 1,
		...initialTaskState,
	},
	cancelled: {
		id: CANCELLED,
		priority: 1,
		...initialTaskState,
	},
	cancellationComplete: {
		id: CANCELLATION_COMPLETE,
		priority: 1,
		...initialTaskState,
	},
};

export default tasks;
